export var AfriexFeatureField;
(function (AfriexFeatureField) {
    AfriexFeatureField["Currency"] = "CURRENCY";
    AfriexFeatureField["Country"] = "COUNTRY";
    AfriexFeatureField["Region"] = "REGION";
    AfriexFeatureField["UserId"] = "USERID";
    AfriexFeatureField["Business"] = "BUSINESS";
    AfriexFeatureField["Email"] = "EMAIL";
    AfriexFeatureField["Group"] = "GROUP";
    AfriexFeatureField["Role"] = "ROLE";
    AfriexFeatureField["OS"] = "OS";
    AfriexFeatureField["IP"] = "IP";
    AfriexFeatureField["SignupDate"] = "SIGNUP_DATE";
    AfriexFeatureField["TransactionCount"] = "TRANSACTION_COUNT";
    AfriexFeatureField["TransactionVolume"] = "TRANSACTION_VOLUME";
})(AfriexFeatureField || (AfriexFeatureField = {}));
export var AfriexFeatureFrequency;
(function (AfriexFeatureFrequency) {
    AfriexFeatureFrequency["Off"] = "OFF";
    AfriexFeatureFrequency["Hourly"] = "HOURLY";
    AfriexFeatureFrequency["Daily"] = "DAILY";
    AfriexFeatureFrequency["Weekly"] = "WEEKLY";
    AfriexFeatureFrequency["Monthly"] = "MONTHLY";
})(AfriexFeatureFrequency || (AfriexFeatureFrequency = {}));
/** The admin feature list's status filter, read from `meta.flags.isDeactivated`. */
export var AfriexFeatureStatus;
(function (AfriexFeatureStatus) {
    AfriexFeatureStatus["Active"] = "active";
    AfriexFeatureStatus["Inactive"] = "inactive";
})(AfriexFeatureStatus || (AfriexFeatureStatus = {}));
//# sourceMappingURL=AfriexFeature.js.map